var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-issues-container"},[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error,staticClass:"has-text-danger"},[_vm._v(" "+_vm._s(error)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }